module.exports = __webpack_public_path__ + "img/banner-join.db93e04f.png";